"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _simpleTranslationProvider = _interopRequireDefault(require("./simpleTranslationProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Template = /*#__PURE__*/function () {
  function Template(dom) {
    var translationProvider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _simpleTranslationProvider["default"];

    _classCallCheck(this, Template);

    this._dom = dom;
    this._translationProvider = translationProvider;

    this._init();

    this._compile();
  }

  _createClass(Template, [{
    key: "_init",
    value: function _init() {
      this._childNodes = [];
      this.namedElements = {};
      this.propertyElements = {};
    }
  }, {
    key: "_compile",
    value: function _compile() {
      var _this = this;

      this._processAttributes('data-name').forEach(function (item) {
        _this.namedElements[item.name] = item.value;
      });

      this._processAttributes('data-property').forEach(function (item) {
        _this.propertyElements[item.name] = item.value;
      });

      this._processAttributes('data-translate').forEach(function (item) {
        item.value.textContent = _this._translationProvider.translate(item.name, item.value);
      });

      this._processAttributes('data-translate-title').forEach(function (item) {
        item.value.title = _this._translationProvider.translate(item.name, item.value);
      });

      this._processAttributes('data-translate-placeholder').forEach(function (item) {
        item.value.placeholder = _this._translationProvider.translate(item.name, item.value);
      });

      this._childNodes = [].slice.call(this._dom.childNodes, 0);
    }
  }, {
    key: "_processAttributes",
    value: function _processAttributes(attrib) {
      var result = [];

      var elements = this._dom.querySelectorAll('[' + attrib + ']');

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var name = element.getAttribute(attrib);
        result.push({
          name: name,
          value: element
        });
      }

      return result;
    }
  }, {
    key: "reclaimChildren",
    value: function reclaimChildren() {
      var _this2 = this;

      this._childNodes.forEach(function (element) {
        return _this2._dom.appendChild(element);
      });
    }
  }, {
    key: "dom",
    get: function get() {
      return this._dom;
    }
  }, {
    key: "childNodes",
    get: function get() {
      return this._childNodes;
    }
  }]);

  return Template;
}();

exports["default"] = Template;